import React, { useEffect } from 'react';
import './FloatingChat.scss';

export const FloatingChat = () => {
    useEffect(() => {
        const onTidioChatApiReady = () => {
            (window as any).tidioChatApi.on('close', () => {
                document.body.classList.remove('tidio-visible');
            });
        };

        if ((window as any).tidioChatApi) {
            onTidioChatApiReady();
        } else {
            document.addEventListener('tidioChat-ready', onTidioChatApiReady);
        }

        return () => {
            document.removeEventListener('tidioChat-ready', onTidioChatApiReady);
        };
    }, []);

    const handleChatClick = () => {
        if ((window as any).tidioChatApi) {
            document.body.classList.add('tidio-visible');
            (window as any).tidioChatApi.show();
            (window as any).tidioChatApi.open();
        }
    };

    return (
        <div className="floating-chat-wrapper">
            <div className="chat-tab" onClick={handleChatClick}>
                <span>Chat with us</span>
            </div>
            <div className="chat-icon-btn" onClick={handleChatClick}>
                <svg viewBox="0 0 24 24" fill="white" style={{height:"15px",width:"15px"}}>
                    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
                </svg>
            </div>
        </div>
    );
};

export default FloatingChat;
